import { Stack, useTheme, useMediaQuery, Typography } from "@mui/material";
import { BarChart, Bar, ResponsiveContainer, XAxis, YAxis, Legend, CartesianGrid } from 'recharts';
import { BarChartSettingsStateType, defaultSettings } from "./BarChartSettings";
import TitleCase from "components/formatting/TitleCase";
import { useTranslation } from "react-i18next";

interface BarChartPreviewProps {
  /**
   * State object represented by series of key value pairs,
   * where the key is a string which represents the title of the
   * updatable settings option.
   */
  settingsState: BarChartSettingsStateType | {};
}

export default function BarChartPreview(props: BarChartPreviewProps) {
  const theme = useTheme();
  const { i18n } = useTranslation();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const windowHeight = window.innerHeight;
  const currentState = {...defaultSettings, ...props.settingsState};

  const dummyData = [
    {
      "name": "Jan",
      "count": 20,
    },
    {
      "name": "Feb",
      "count": 50,
    },
    {
      "name": "Mar",
      "count": 30,
    }
  ];
  
  return (
    <Stack
      sx={{
        gap: 3,
        width: isSmallScreen ? "100%" : "50%",
        flex: 1,
        height: windowHeight < 600 ? "35vh" : "55vh"
      }}>
      {currentState.widgetTitle !== 'none' &&
        <Typography
          sx={{ fontSize: "1.2rem", textAlign: `${currentState.widgetTitleAlignment}` }}
          variant="subtitle2">
          <TitleCase text={`${currentState.widgetTitle} ${i18n.t("title")}`} />
        </Typography>
      }
      <ResponsiveContainer
        width="100%"
        aspect={windowHeight < 600 ? 0 : 1}
        className={isSmallScreen ? "mobile" : ""}
      >
        <BarChart data={dummyData} margin={{ top: 0, right: 0, bottom: 0, left: 0 }}>
          {currentState.xAxis && <XAxis dataKey="name" />}
          {currentState.yAxis && <YAxis />}
          {currentState.showGrid && <CartesianGrid strokeDasharray="3 3" />}
          {currentState.showLegend && <Legend />}
          <Bar dataKey="count" fill={theme.palette.primary.main} />
        </BarChart>
      </ResponsiveContainer>
    </Stack>
  );
}